import type { Module } from 'vuex';
import { state } from './state';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import type { IScoreProgressionState } from '@/store/modules/report/score-progression/types';
import type { RootState } from '@/store/types';

const namespaced: boolean = true;

export const scoreProgressionModule: Module<IScoreProgressionState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
